(function () {
  function pad2(n) {
    return String(Math.max(0, Math.floor(n))).padStart(2, '0');
  }

  /** Tempo restante no slot atual, em milissegundos */
  function remainingMs(slotSec) {
    var slotMs = slotSec * 1000;
    var now = Date.now();
    var pos = now % slotMs;
    return pos === 0 ? slotMs : slotMs - pos;
  }

  function tickEl(el) {
    var slotSec = parseInt(el.getAttribute('data-slot-sec'), 10);
    if (!slotSec || slotSec < 60) return;
    var remMs = remainingMs(slotSec);
    var remSec = Math.floor(remMs / 1000);
    var ms = Math.floor(remMs % 1000);
    var h = Math.floor(remSec / 3600);
    var m = Math.floor((remSec % 3600) / 60);
    var s = remSec % 60;
    var hN = el.querySelector('[data-uc-h]');
    var mN = el.querySelector('[data-uc-m]');
    var sN = el.querySelector('[data-uc-s]');
    var msN = el.querySelector('[data-uc-ms]');
    if (hN) hN.textContent = pad2(h);
    if (mN) mN.textContent = pad2(m);
    if (sN) sN.textContent = pad2(s);
    if (msN) msN.textContent = String(ms).padStart(3, '0');
  }

  function tickAll() {
    document.querySelectorAll('[data-urgency-countdown]').forEach(tickEl);
  }

  function run() {
    tickAll();
    setInterval(tickAll, 32);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
